import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Adjunto from "./Adjunto";
import Galeria from "./Galeria";
import ListaAdjuntos from "./ListaAdjuntos";
import ReportePDF from "./ReportePDF";

class F28s extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      banco: "",
      numero_de_cuenta: "",
      saldo_segun_el_estado_de_cuenta_bancario: 0,
      depositos_no_registrados: [],
      cargos_no_contabilizados: [],
      cheques_no_cobrados: [],
      no_considerados: [],
      total_no_registrado: 0,
      total_no_contabilizado: 0,
      total_no_cobrado: 0,
      total_no_considerados: 0,
      saldo_segun_auxiliar: 0,
      observaciones: "",
      usuario_id: "",
      ambito_id: "",

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      f28s: [], // Listado de elementos para la tabla
      loading: false,
      noEdit: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
  }
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  noEditFnc = async () => {
    let noEdit = false
    let busca = this.props.location.pathname.split("/")
    busca.shift()
    let misAmbitos = localStorage.ambitos.split(",")

    if (busca[2]) {
      let res = null
      res = await axios({
        method: "get",
        url:
          "http://143.198.191.211/api/Ambito/" +
          busca[2] +
          "?api_token=" +
          localStorage.api_token,
        data: {},
      })

      let data = res.data
      if (data.fecha_finalizado != null) {
        noEdit = true
      } else {
        if (misAmbitos.includes(busca[2])) {
          noEdit = false
        } else {
          noEdit = true
        }
      }

      if (localStorage.permisos.includes("admin")) {
        noEdit = false
      }
    }
    if (noEdit) {
      this.setState({ noEdit: true })
    } else {
      this.setState({ noEdit: false })
    }
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/F28/ambito/" +
        this.props.match.params.ambito_id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ f28s: res.data, loading: false });
    }).finally(() => {
      this.noEditFnc();
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        this.props.match.params.ambito_id +
        "/28/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      banco: "",
      numero_de_cuenta: "",
      saldo_segun_el_estado_de_cuenta_bancario: 0,
      depositos_no_registrados: [],
      cargos_no_contabilizados: [],
      cheques_no_cobrados: [],
      no_considerados: [],
      total_no_registrado: 0,
      total_no_contabilizado: 0,
      total_no_cobrado: 0,
      total_no_considerados: 0,
      saldo_segun_auxiliar: 0,
      observaciones: "",
      usuario_id: "",
      ambito_id: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      banco: row.banco,
      numero_de_cuenta: row.numero_de_cuenta,
      saldo_segun_el_estado_de_cuenta_bancario: row.saldo_segun_el_estado_de_cuenta_bancario,
      depositos_no_registrados: JSON.parse(row.depositos_no_registrados),
      cargos_no_contabilizados: JSON.parse(row.cargos_no_contabilizados),
      cheques_no_cobrados: JSON.parse(row.cheques_no_cobrados),
      no_considerados: JSON.parse(row.no_considerados),
      total_no_registrado: row.total_no_registrado,
      total_no_contabilizado: row.total_no_contabilizado,
      total_no_cobrado: row.total_no_cobrado,
      total_no_considerados: row.total_no_considerados,
      saldo_segun_auxiliar: row.saldo_segun_auxiliar,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      banco: row.banco,
      numero_de_cuenta: row.numero_de_cuenta,
      saldo_segun_el_estado_de_cuenta_bancario: row.saldo_segun_el_estado_de_cuenta_bancario,
      depositos_no_registrados: JSON.parse(row.depositos_no_registrados),
      cargos_no_contabilizados: JSON.parse(row.cargos_no_contabilizados),
      cheques_no_cobrados: JSON.parse(row.cheques_no_cobrados),
      no_considerados: JSON.parse(row.no_considerados),
      total_no_registrado: row.total_no_registrado,
      total_no_contabilizado: row.total_no_contabilizado,
      total_no_cobrado: row.total_no_cobrado,
      total_no_considerados: row.total_no_considerados,
      saldo_segun_auxiliar: row.saldo_segun_auxiliar,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id,
      banco: row.banco,
      numero_de_cuenta: row.numero_de_cuenta,
      saldo_segun_el_estado_de_cuenta_bancario: row.saldo_segun_el_estado_de_cuenta_bancario,
      depositos_no_registrados: row.depositos_no_registrados,
      cargos_no_contabilizados: row.cargos_no_contabilizados,
      cheques_no_cobrados: row.cheques_no_cobrados,
      no_considerados: row.no_considerados,
      total_no_registrado: row.total_no_registrado,
      total_no_contabilizado: row.total_no_contabilizado,
      total_no_cobrado: row.total_no_cobrado,
      total_no_considerados: row.total_no_considerados,
      saldo_segun_auxiliar: row.saldo_segun_auxiliar,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      banco: this.state.banco,
      numero_de_cuenta: this.state.numero_de_cuenta,
      saldo_segun_el_estado_de_cuenta_bancario: this.state.saldo_segun_el_estado_de_cuenta_bancario,
      depositos_no_registrados: this.state.depositos_no_registrados,
      cargos_no_contabilizados: this.state.cargos_no_contabilizados,
      cheques_no_cobrados: this.state.cheques_no_cobrados,
      no_considerados: this.state.no_considerados,
      total_no_registrado: this.state.total_no_registrado,
      total_no_contabilizado: this.state.total_no_contabilizado,
      total_no_cobrado: this.state.total_no_cobrado,
      total_no_considerados: this.state.total_no_considerados,
      saldo_segun_auxiliar: this.state.saldo_segun_auxiliar,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios.post("http://143.198.191.211/api/F28", data, config).then((res) => {
      this.closeModal();
      toast.success(res.data.text, { autoClose: 1000 });
      this.cargaTabla();
      this.setState({ loading: false });
    });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      banco: this.state.banco,
      numero_de_cuenta: this.state.numero_de_cuenta,
      saldo_segun_el_estado_de_cuenta_bancario: this.state.saldo_segun_el_estado_de_cuenta_bancario,
      depositos_no_registrados: this.state.depositos_no_registrados,
      cargos_no_contabilizados: this.state.cargos_no_contabilizados,
      cheques_no_cobrados: this.state.cheques_no_cobrados,
      no_considerados: this.state.no_considerados,
      total_no_registrado: this.state.total_no_registrado,
      total_no_contabilizado: this.state.total_no_contabilizado,
      total_no_cobrado: this.state.total_no_cobrado,
      total_no_considerados: this.state.total_no_considerados,
      saldo_segun_auxiliar: this.state.saldo_segun_auxiliar,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put("http://143.198.191.211/api/F28/" + this.state.id, data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/F28/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeBanco = e => {
    this.setState({ banco: e.target.value });
  };

  onChangeNumeroDeCuenta = e => {
    this.setState({ numero_de_cuenta: e.target.value });
  };

  onChangeSaldoSegunElEstadoDeCuentaBancario = e => {
    let saldo_segun_auxiliar = parseFloat(e.target.value)
      + parseFloat(this.state.total_no_registrado)
      + parseFloat(this.state.total_no_contabilizado)
      - parseFloat(this.state.total_no_cobrado)
      + parseFloat(this.state.total_no_considerados)
    this.setState({ saldo_segun_el_estado_de_cuenta_bancario: e.target.value, saldo_segun_auxiliar: saldo_segun_auxiliar });
  };

  onChangeDepositosNoRegistrados = e => {
    this.setState({ depositos_no_registrados: e.target.value });
  };

  onChangeCargosNoContabilizados = e => {
    this.setState({ cargos_no_contabilizados: e.target.value });
  };

  onChangeChequesNoCobrados = e => {
    this.setState({ cheques_no_cobrados: e.target.value });
  };

  onChangeNoConsiderados = e => {
    this.setState({ no_considerados: e.target.value });
  };

  onChangeSaldoSegunAuxiliar = e => {
    this.setState({ saldo_segun_auxiliar: e.target.value });
  };

  onChangeObservaciones = e => {
    this.setState({ observaciones: e.target.value });
  };

  onChangeUsuarioId = e => {
    this.setState({ usuario_id: e.target.value });
  };

  onChangeAmbitoId = e => {
    this.setState({ ambito_id: e.target.value });
  };

  onChangeFechaNR = (i, e) => {
    let elementos = [...this.state.depositos_no_registrados]
    let elemento = { ...elementos[i] }
    elemento.fecha = e.target.value
    elementos[i] = elemento
    this.setState({ depositos_no_registrados: elementos })
  };

  onChangeDescripcionNR = (i, e) => {
    let elementos = [...this.state.depositos_no_registrados]
    let elemento = { ...elementos[i] }
    elemento.descripcion = e.target.value
    elementos[i] = elemento
    this.setState({ depositos_no_registrados: elementos })
  };

  onChangeCantidadNR = (i, e) => {
    let elementos = [...this.state.depositos_no_registrados]
    let elemento = { ...elementos[i] }
    elemento.cantidad = e.target.value
    elementos[i] = elemento
    let total_no_registrado = 0
    elementos.forEach(el => {
      total_no_registrado = parseFloat(el.cantidad) + parseFloat(total_no_registrado)
    });
    let saldo_segun_auxiliar = parseFloat(this.state.saldo_segun_el_estado_de_cuenta_bancario)
      + parseFloat(total_no_registrado)
      + parseFloat(this.state.total_no_contabilizado)
      - parseFloat(this.state.total_no_cobrado)
      + parseFloat(this.state.total_no_considerados)
    this.setState({
      depositos_no_registrados: elementos,
      total_no_registrado: total_no_registrado,
      saldo_segun_auxiliar: saldo_segun_auxiliar
    })
  };

  onChangeFechaNC = (i, e) => {
    let elementos = [...this.state.cargos_no_contabilizados]
    let elemento = { ...elementos[i] }
    elemento.fecha = e.target.value
    elementos[i] = elemento
    this.setState({ cargos_no_contabilizados: elementos })
  };

  onChangeDescripcionNC = (i, e) => {
    let elementos = [...this.state.cargos_no_contabilizados]
    let elemento = { ...elementos[i] }
    elemento.descripcion = e.target.value
    elementos[i] = elemento
    this.setState({ cargos_no_contabilizados: elementos })
  };

  onChangeCantidadNC = (i, e) => {
    let elementos = [...this.state.cargos_no_contabilizados]
    let elemento = { ...elementos[i] }
    elemento.cantidad = e.target.value
    elementos[i] = elemento
    let total_no_contabilizado = 0
    elementos.forEach(el => {
      total_no_contabilizado = parseFloat(el.cantidad) + parseFloat(total_no_contabilizado)
    });
    let saldo_segun_auxiliar = parseFloat(this.state.saldo_segun_el_estado_de_cuenta_bancario)
      + parseFloat(this.state.total_no_registrado)
      + parseFloat(total_no_contabilizado)
      - parseFloat(this.state.total_no_cobrado)
      + parseFloat(this.state.total_no_considerados)
    this.setState({
      cargos_no_contabilizados: elementos,
      total_no_contabilizado: total_no_contabilizado,
      saldo_segun_auxiliar: saldo_segun_auxiliar
    })
  };

  onChangeFechaCNC = (i, e) => {
    let elementos = [...this.state.cheques_no_cobrados]
    let elemento = { ...elementos[i] }
    elemento.fecha = e.target.value
    elementos[i] = elemento
    this.setState({ cheques_no_cobrados: elementos })
  };

  onChangeDescripcionCNC = (i, e) => {
    let elementos = [...this.state.cheques_no_cobrados]
    let elemento = { ...elementos[i] }
    elemento.descripcion = e.target.value
    elementos[i] = elemento
    this.setState({ cheques_no_cobrados: elementos })
  };

  onChangeCantidadCNC = (i, e) => {
    let elementos = [...this.state.cheques_no_cobrados]
    let elemento = { ...elementos[i] }
    elemento.cantidad = e.target.value
    elementos[i] = elemento
    let total_no_cobrado = 0
    elementos.forEach(el => {
      total_no_cobrado = parseFloat(el.cantidad) + parseFloat(total_no_cobrado)
    });
    let saldo_segun_auxiliar = parseFloat(this.state.saldo_segun_el_estado_de_cuenta_bancario)
      + parseFloat(this.state.total_no_registrado)
      + parseFloat(this.state.total_no_contabilizado)
      - parseFloat(total_no_cobrado)
      + parseFloat(this.state.total_no_considerados)
    this.setState({
      cheques_no_cobrados: elementos,
      total_no_cobrado: total_no_cobrado,
      saldo_segun_auxiliar: saldo_segun_auxiliar
    })
  };

  onChangeFechaNCON = (i, e) => {
    let elementos = [...this.state.no_considerados]
    let elemento = { ...elementos[i] }
    elemento.fecha = e.target.value
    elementos[i] = elemento
    this.setState({ no_considerados: elementos })
  };

  onChangeDescripcionNCON = (i, e) => {
    let elementos = [...this.state.no_considerados]
    let elemento = { ...elementos[i] }
    elemento.descripcion = e.target.value
    elementos[i] = elemento
    this.setState({ no_considerados: elementos })
  };

  onChangeCantidadNCON = (i, e) => {
    let elementos = [...this.state.no_considerados]
    let elemento = { ...elementos[i] }
    elemento.cantidad = e.target.value
    elementos[i] = elemento
    let total_no_considerados = 0
    elementos.forEach(el => {
      total_no_considerados = parseFloat(el.cantidad) + parseFloat(total_no_considerados)
    });
    let saldo_segun_auxiliar = parseFloat(this.state.saldo_segun_el_estado_de_cuenta_bancario)
      + parseFloat(this.state.total_no_registrado)
      + parseFloat(this.state.total_no_contabilizado)
      - parseFloat(this.state.total_no_cobrado)
      + parseFloat(total_no_considerados)
    this.setState({
      no_considerados: elementos,
      total_no_considerados: total_no_considerados,
      saldo_segun_auxiliar: saldo_segun_auxiliar
    })
  };

  addNoRegistrado = (e) => {
    let elemento = { fecha: null, descripcion: "", cantidad: 0 }
    let elementos = [...this.state.depositos_no_registrados, elemento]
    this.setState({ depositos_no_registrados: elementos })
  };

  dellNoRegistrado = (i) => {
    let elementos = this.state.depositos_no_registrados
    elementos.splice(i, 1)

    let total_no_registrado = 0
    elementos.forEach(el => {
      total_no_registrado = parseFloat(el.cantidad) + parseFloat(total_no_registrado)
    });
    let saldo_segun_auxiliar = parseFloat(this.state.saldo_segun_el_estado_de_cuenta_bancario)
      + parseFloat(total_no_registrado)
      + parseFloat(this.state.total_no_contabilizado)
      - parseFloat(this.state.total_no_cobrado)
      + parseFloat(this.state.total_no_considerados)
    this.setState({
      depositos_no_registrados: elementos,
      total_no_registrado: total_no_registrado,
      saldo_segun_auxiliar: saldo_segun_auxiliar
    })
  };

  addNoContabilizado = (e) => {
    let elemento = { fecha: null, descripcion: "", cantidad: 0 }
    let elementos = [...this.state.cargos_no_contabilizados, elemento]
    this.setState({ cargos_no_contabilizados: elementos })
  };

  dellNoContabilizado = (i) => {
    console.log(i)
    let elementos = this.state.cargos_no_contabilizados
    elementos.splice(i, 1)

    let total_no_contabilizado = 0
    elementos.forEach(el => {
      total_no_contabilizado = parseFloat(el.cantidad) + parseFloat(total_no_contabilizado)
    });
    let saldo_segun_auxiliar = parseFloat(this.state.saldo_segun_el_estado_de_cuenta_bancario)
      + parseFloat(this.state.total_no_registrado)
      + parseFloat(total_no_contabilizado)
      - parseFloat(this.state.total_no_cobrado)
      + parseFloat(this.state.total_no_considerados)
    this.setState({
      cargos_no_contabilizados: elementos,
      total_no_contabilizado: total_no_contabilizado,
      saldo_segun_auxiliar: saldo_segun_auxiliar
    })
  };

  addNoCobrado = (e) => {
    let elemento = { fecha: null, descripcion: "", cantidad: 0 }
    let elementos = [...this.state.cheques_no_cobrados, elemento]
    this.setState({ cheques_no_cobrados: elementos })
  };

  dellNoCobrado = (i) => {
    let elementos = this.state.cheques_no_cobrados
    elementos.splice(i, 1)

    let total_no_cobrado = 0
    elementos.forEach(el => {
      total_no_cobrado = parseFloat(el.cantidad) + parseFloat(total_no_cobrado)
    });
    let saldo_segun_auxiliar = parseFloat(this.state.saldo_segun_el_estado_de_cuenta_bancario)
      + parseFloat(this.state.total_no_registrado)
      + parseFloat(this.state.total_no_contabilizado)
      - parseFloat(total_no_cobrado)
      + parseFloat(this.state.total_no_considerados)
    this.setState({
      cheques_no_cobrados: elementos,
      total_no_cobrado: total_no_cobrado,
      saldo_segun_auxiliar: saldo_segun_auxiliar
    })
  };

  addNoConsiderados = (e) => {
    let elemento = { fecha: null, descripcion: "", cantidad: 0 }
    let elementos = [...this.state.no_considerados, elemento]
    this.setState({ no_considerados: elementos })
  };

  dellNoConsiderados = (i) => {
    let elementos = this.state.no_considerados
    elementos.splice(i, 1)

    let total_no_considerados = 0
    elementos.forEach(el => {
      total_no_considerados = parseFloat(el.cantidad) + parseFloat(total_no_considerados)
    });
    let saldo_segun_auxiliar = parseFloat(this.state.saldo_segun_el_estado_de_cuenta_bancario)
      + parseFloat(this.state.total_no_registrado)
      + parseFloat(this.state.total_no_contabilizado)
      - parseFloat(this.state.total_no_cobrado)
      + parseFloat(total_no_considerados)
    this.setState({
      no_considerados: elementos,
      total_no_considerados: total_no_considerados,
      saldo_segun_auxiliar: saldo_segun_auxiliar
    })
  };

  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row, idx, noEdit) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <Adjunto
            ambito_id={this.props.match.params.ambito_id}
            formato={"28"}
            id={row.id}
            disabled={noEdit}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm btn-elimina"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled={noEdit}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  render() {
    const columns = [
      {
        dataField: "banco",
        text: "Banco",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "numero_de_cuenta",
        text: "Numero De Cuenta",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "saldo_segun_el_estado_de_cuenta_bancario",
        text: "Saldo Segun El Estado De Cuenta Bancario",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "total_no_registrado",
        text: "Depositos No Registrados Por El Banco",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "total_no_contabilizado",
        text: "Cargos Bancarios No Contabilizados",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "total_no_cobrado",
        text: "Cheques No Cobrados (En Transito)",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "total_no_considerados",
        text: "Cargos Nuestros No Considerados Por El Banco",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "saldo_segun_auxiliar",
        text: "Saldo Segun Auxiliar",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones",
        text: "Observaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        formatExtraData: this.state.noEdit,
        headerStyle: () => {
          return {
            width: "140px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">CONCILIACIÓN BANCARIA</h3>
              <br />
              <small className="text-muted">
                Gestione la información del anexo numero 28 referente
                a conciliación bancaria, para el ámbito {this.props.match.params.ambito_id}
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.f28s}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <button
                              className="btn btn-primary btn-nuevo"
                              onClick={this.ModalNuevo}
                              data-tip="Nuevo"
                              disabled={this.state.noEdit}
                            >
                              <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                          </ButtonGroup>
                          <ButtonGroup
                            className="mr-2"
                            aria-label="Second group"
                          >
                            <ReportePDF ambito_id={this.props.match.params.ambito_id}
                              anexo="28" />
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga Excel"
                              target="_blank"
                              href={
                                "http://143.198.191.211/xlsx/?a=" +
                                this.props.match.params.ambito_id +
                                "&f=28"
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Descargar
                              Excel
                            </a>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              <Col xs="12" md="4" lg="4">
                <Form.Label>
                  Banco:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="banco"
                  value={this.state.banco}
                  onChange={this.onChangeBanco}
                />
              </Col>
              <Col xs="12" md="4" lg="5">
                <Form.Label>
                  Numero De Cuenta:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="numero_de_cuenta"
                  value={this.state.numero_de_cuenta}
                  onChange={this.onChangeNumeroDeCuenta}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Saldo Segun El Estado De Cuenta Bancario:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="saldo_segun_el_estado_de_cuenta_bancario"
                  value={this.state.saldo_segun_el_estado_de_cuenta_bancario}
                  onChange={this.onChangeSaldoSegunElEstadoDeCuentaBancario}
                />
              </Col>
              <Col xs="12"><br></br></Col>
              <Col xs="12" md="8" lg="9">
                <b><span className="text-muted">(+)</span> Depositos No Registrados Por El Banco</b>
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Control
                  type="number"
                  step="0.01"
                  name="total_no_registrado"
                  value={this.state.total_no_registrado}
                  disabled
                />
              </Col>
              <Col xs="12">
                {(this.state.depositos_no_registrados).map((ele, i) =>
                  <Row key={i}>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Fecha:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="date"
                        name="fecha"
                        value={ele.fecha}
                        onChange={(e) => this.onChangeFechaNR(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="5">
                      {i == 0 &&
                        <Form.Label>
                          Descripción:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="text"
                        name="descripcion"
                        value={ele.descripcion}
                        onChange={(e) => this.onChangeDescripcionNR(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Cantidad:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="number"
                        name="cantidad"
                        value={ele.cantidad}
                        onChange={(e) => this.onChangeCantidadNR(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="1">
                      {i == 0 &&
                        <Form.Label>
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Eliminar Deposito No Registrado" });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      {i == 0 && <br></br>}
                      <button
                        className="btn btn-danger"
                        onClick={(e) => this.dellNoRegistrado(i, e)}
                        data-tip="Eliminar Deposito No Registrado"
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>
                    </Col>
                  </Row>
                )}
                <br></br>
                <Row className="justify-content-md-center">
                  <Col md="auto">
                    <button
                      className="btn btn-primary btn-add-anidado"
                      onClick={this.addNoRegistrado}
                      data-tip="Agregar Deposito No Registrado"
                    >
                      <FontAwesomeIcon icon={faPlus} /> Agregar Elemento
                    </button>
                  </Col>
                </Row>
              </Col>
              <Col xs="12" md="8" lg="9">
                <b><span className="text-muted">(+)</span> Cargos Bancarios No Contabilizados</b>
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Control
                  type="number"
                  step="0.01"
                  name="total_no_contabilizado"
                  value={this.state.total_no_contabilizado}
                  disabled
                />
              </Col>
              <Col xs="12">
                {(this.state.cargos_no_contabilizados).map((ele, i) =>
                  <Row key={i}>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Fecha:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="date"
                        name="fecha"
                        value={ele.fecha}
                        onChange={(e) => this.onChangeFechaNC(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="5">
                      {i == 0 &&
                        <Form.Label>
                          Descripción:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="text"
                        name="descripcion"
                        value={ele.descripcion}
                        onChange={(e) => this.onChangeDescripcionNC(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Cantidad:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="number"
                        name="cantidad"
                        value={ele.cantidad}
                        onChange={(e) => this.onChangeCantidadNC(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="1">
                      {i == 0 &&
                        <Form.Label>
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Eliminar Cargo No Contabilizado" });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      {i == 0 && <br></br>}
                      <button
                        className="btn btn-danger"
                        onClick={(e) => this.dellNoContabilizado(i, e)}
                        data-tip="Eliminar Cargo No Contabilizado"
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>
                    </Col>
                  </Row>
                )}
                <br></br>
                <Row className="justify-content-md-center">
                  <Col md="auto">
                    <button
                      className="btn btn-primary btn-add-anidado"
                      onClick={this.addNoContabilizado}
                      data-tip="Agregar Cargo No Contabilizado"
                    >
                      <FontAwesomeIcon icon={faPlus} /> Agregar Elemento
                    </button>
                  </Col>
                </Row>
              </Col>
              <Col xs="12" md="8" lg="9">
                <b><span className="text-muted">(-)</span> Cheques No Cobrados (En Transito)</b>
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Control
                  type="number"
                  step="0.01"
                  name="total_no_cobrado"
                  value={this.state.total_no_cobrado}
                  disabled
                />
              </Col>
              <Col xs="12">
                {(this.state.cheques_no_cobrados).map((ele, i) =>
                  <Row key={i}>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Fecha:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="date"
                        name="fecha"
                        value={ele.fecha}
                        onChange={(e) => this.onChangeFechaCNC(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="5">
                      {i == 0 &&
                        <Form.Label>
                          Descripción:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="text"
                        name="descripcion"
                        value={ele.descripcion}
                        onChange={(e) => this.onChangeDescripcionCNC(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Cantidad:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="number"
                        name="cantidad"
                        value={ele.cantidad}
                        onChange={(e) => this.onChangeCantidadCNC(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="1">
                      {i == 0 &&
                        <Form.Label>
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Eliminar Cheque No Cobrado" });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      {i == 0 && <br></br>}
                      <button
                        className="btn btn-danger"
                        onClick={(e) => this.dellNoCobrado(i, e)}
                        data-tip="Eliminar Cheque No Cobrado"
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>
                    </Col>
                  </Row>
                )}
                <br></br>
                <Row className="justify-content-md-center">
                  <Col md="auto">
                    <button
                      className="btn btn-primary btn-add-anidado"
                      onClick={this.addNoCobrado}
                      data-tip="Agregar Cheque No Cobrado"
                    >
                      <FontAwesomeIcon icon={faPlus} /> Agregar Elemento
                    </button>
                  </Col>
                </Row>
              </Col>

              <Col xs="12" md="8" lg="9">
              </Col>



              <Col xs="12" md="8" lg="9">
                <b><span className="text-muted">(+)</span> Cargos Nuestros No Considerados Por El Banco</b>
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Control
                  type="number"
                  step="0.01"
                  name="total_no_considerados"
                  value={this.state.total_no_considerados}
                  disabled
                />
              </Col>
              <Col xs="12">
                {(this.state.no_considerados).map((ele, i) =>
                  <Row key={i}>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Fecha:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="date"
                        name="fecha"
                        value={ele.fecha}
                        onChange={(e) => this.onChangeFechaNCON(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="5">
                      {i == 0 &&
                        <Form.Label>
                          Descripción:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="text"
                        name="descripcion"
                        value={ele.descripcion}
                        onChange={(e) => this.onChangeDescripcionNCON(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Cantidad:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="number"
                        name="cantidad"
                        value={ele.cantidad}
                        onChange={(e) => this.onChangeCantidadNCON(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="1">
                      {i == 0 &&
                        <Form.Label>
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Eliminar Cargo No Considerado" });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      {i == 0 && <br></br>}
                      <button
                        className="btn btn-danger"
                        onClick={(e) => this.dellNoConsiderados(i, e)}
                        data-tip="Eliminar Cargo No Considerado"
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>
                    </Col>
                  </Row>
                )}
                <br></br>
                <Row className="justify-content-md-center">
                  <Col md="auto">
                    <button
                      className="btn btn-primary btn-add-anidado"
                      onClick={this.addNoConsiderados}
                      data-tip="Agregar Cargo No Considerado"
                    >
                      <FontAwesomeIcon icon={faPlus} /> Agregar Elemento
                    </button>
                  </Col>
                </Row>
              </Col>



              <Col xs="12" md="8" lg="9">
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Saldo Segun Auxiliar:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="saldo_segun_auxiliar"
                  value={this.state.saldo_segun_auxiliar}
                  disabled
                />
              </Col>
              <Col xs="12" md="12" lg="12">
                <Form.Label>
                  Observaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones"
                  value={this.state.observaciones}
                  onChange={this.onChangeObservaciones}
                />
              </Col>

            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.ejecutar} className="btn-ejecutar" disabled={this.state.noEdit} >
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.ejecutar} disabled={this.state.noEdit}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12} md={8}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Banco:
                    </Col>
                    <Col xs={10}>{this.state.banco}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Numero De Cuenta:
                    </Col>
                    <Col xs={10}>{this.state.numero_de_cuenta}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Saldo Segun El Estado De Cuenta Bancario:
                    </Col>
                    <Col xs={10}>{this.state.saldo_segun_el_estado_de_cuenta_bancario}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Total Depositos No Registrados:
                    </Col>
                    <Col xs={10}>{this.state.total_no_registrado}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Total Cargos No Contabilizados:
                    </Col>
                    <Col xs={10}>{this.state.total_no_contabilizado}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Total Cheques No Cobrados:
                    </Col>
                    <Col xs={10}>{this.state.total_no_cobrado}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Cargos Nuestros No Considerados Por El Banco:
                    </Col>
                    <Col xs={10}>{this.state.total_no_considerados}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Saldo Segun Auxiliar:
                    </Col>
                    <Col xs={10}>{this.state.saldo_segun_auxiliar}</Col>
                  </Row>

                </Col>
                <Col xs={12} md={4}>
                  <Row>
                    <Col xs={12}>
                      <h5>Archivos Adjuntos</h5>
                    </Col>
                    <Col xs={12}>
                      <ListaAdjuntos archivos={this.state.frm_lista_documentos} cargaDocumentos={this.cargaDocumentos} rowId={this.state.id} />
                    </Col>
                    <Col xs={12}>
                      <Galeria imagenes={this.state.frm_lista_documentos} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <ReactTooltip />
      </Layout >
    );
  }
}

export default F28s;
